import { Link } from "react-router-dom";
import type { SearchResult } from "@/lib/content";
import HighlightText from "@/components/base/HighlightText";

const kindLabel: Record<string, string> = {
  synopsis: "剧情介绍",
  cast: "主演信息",
  updates: "剧集更新",
};

interface SearchResultRowProps {
  result: SearchResult;
  keyword: string;
}

export default function SearchResultRow({ result, keyword }: SearchResultRowProps) {
  const to = result.episodeId ? `/detail/${result.episodeId}` : "/category/updates";
  const isCast = result.kind === "cast";

  return (
    <Link
      to={to}
      className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300"
    >
      <div
        className={
          isCast
            ? "h-16 w-16 flex-shrink-0 overflow-hidden rounded-full bg-background-200"
            : "h-16 w-28 flex-shrink-0 overflow-hidden rounded-md bg-background-200"
        }
      >
        <img
          src={result.image}
          alt={result.title}
          title={result.title}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-2">
          <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 font-label text-[11px] text-secondary-900">
            {kindLabel[result.kind]}
          </span>
          <span className="font-label text-[11px] text-foreground-400">{result.meta}</span>
        </div>
        <h3 className="mt-1.5 font-heading text-base font-semibold text-foreground-900 transition-colors group-hover:text-primary-700">
          <HighlightText text={result.title} keyword={keyword} />
        </h3>
        <p className="mt-1.5 line-clamp-2 font-label text-sm leading-relaxed text-foreground-600">
          <HighlightText text={result.excerpt} keyword={keyword} />
        </p>
      </div>
    </Link>
  );
}